import { Box } from "@mui/material";
import { motion } from "framer-motion";

export default function LoadingSpinner({
    size = 34,
    barWidth = 3,
    barHeight = 8,
    color = "#000",
}) {
    const bars = Array.from({ length: 12 });

    const radius = size / 2 - barHeight / 2;
    const total = bars.length;
    const duration = 1;

    return (
        <Box
            sx={{
                width: size,
                height: size,
                position: "relative",
            }}
        >
            {bars.map((_, i) => {
                const angle = (360 / total) * i;
                const delay = (i / total) * duration;

                return (
                    <motion.div
                        key={i}
                        initial={{ opacity: 0.2 }}
                        animate={{ opacity: [1, 0.2, 1] }}
                        transition={{
                            duration,
                            repeat: Infinity,
                            ease: "easeInOut",
                            delay,
                        }}
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            width: barWidth,
                            height: barHeight,
                            background: color,
                            borderRadius: 999,
                            transform: `
                translate(-50%, -50%)
                rotate(${angle}deg)
                translate(0, -${radius}px)
              `,
                        }}
                    />
                );
            })}
        </Box>
    );
}
